import { ISerpApiSearchResult } from "../models/PartLookup";

export interface IIntelligencePriceSummary {
  min: number;
  max: number;
  avg: number;
}

/** Whether the AI result filter took this listing out of the price figures. */
export function isExcluded(result: ISerpApiSearchResult): boolean {
  return !!result.excludedReason && result.excludedReason.trim().length > 0;
}

/**
 * Min, max and mean asking price of the eBay listings Wilma Intelligence returned, rounded to the
 * penny. Listings without a positive price, and listings the AI result filter excluded, are ignored;
 * null when none are left. Matches the API's IntelligencePriceSummary, which stores the same figures
 * on the part.
 */
export function summarisePrices(
  results: ISerpApiSearchResult[] | null | undefined,
): IIntelligencePriceSummary | null {
  const prices = (results ?? [])
    .filter((r) => !isExcluded(r))
    .map((r) => r.priceExtracted)
    .filter((p): p is number => p != null && p > 0);

  if (prices.length === 0) return null;

  const round = (n: number) => Math.round(n * 100) / 100;

  return {
    min: round(Math.min(...prices)),
    max: round(Math.max(...prices)),
    avg: round(prices.reduce((sum, p) => sum + p, 0) / prices.length),
  };
}
